import React, { createContext, useContext, useState, ReactNode } from 'react';
import { WhatsAppConfirmationRequest } from '../services/whatsapp.service';

// Interfaz para el contexto de WhatsApp
interface WhatsAppContextType {
  whatsappData: Partial<WhatsAppConfirmationRequest>;
  updateWhatsAppData: (data: Partial<WhatsAppConfirmationRequest>) => void;
  resetWhatsAppData: () => void;
}

// Crear el contexto
const WhatsAppContext = createContext<WhatsAppContextType | undefined>(undefined);

// Props para el proveedor
interface WhatsAppProviderProps {
  children: ReactNode;
}

// Proveedor del contexto de WhatsApp
export const WhatsAppProvider: React.FC<WhatsAppProviderProps> = ({ children }) => {
  const [whatsappData, setWhatsappData] = useState<Partial<WhatsAppConfirmationRequest>>({});

  // Función para actualizar los datos de WhatsApp
  const updateWhatsAppData = (data: Partial<WhatsAppConfirmationRequest>) => {
    setWhatsappData(prevData => ({
      ...prevData,
      ...data
    }));
  };

  // Función para resetear los datos de WhatsApp
  const resetWhatsAppData = () => {
    setWhatsappData({});
  };

  // Valor del contexto
  const value = {
    whatsappData,
    updateWhatsAppData,
    resetWhatsAppData
  };

  return (
    <WhatsAppContext.Provider value={value}>
      {children}
    </WhatsAppContext.Provider>
  );
};

// Hook personalizado para usar el contexto de WhatsApp
export const useWhatsApp = () => {
  const context = useContext(WhatsAppContext);
  if (context === undefined) {
    throw new Error('useWhatsApp debe ser usado dentro de un WhatsAppProvider');
  }
  return context;
};
